import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { post } from '../api/api';

const db = firebase.firestore();

type LoadingState = {
  isLoading: boolean,
  error: Error | string | null;
};

const initialState: LoadingState = {
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { startLoading } = slice.actions;

export default slice.reducer;

export function saveLead(user: { name: string, email: string }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await db.collection("users").add(user);
      return true
    } catch (error) {
      return false
    }
  };
}

export function createPaymentAsaas(data: any) {
  return async () => {
    try {
      console.log(data)
      const response = await post('/order/create', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}